var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"empty-state"},[_c('img',{attrs:{"src":require(`../../assets/img/${_vm.image}`)}}),_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }